import React from 'react';

/**
 * Resultados de exámenes que el paciente trae de antes.
 *
 * Apagar la casilla NO borra lo escrito: solo marca que la sección no se imprime.
 * Un clic accidental con la consulta ya redactada perdería el trabajo del médico.
 */
function PreviousLabResultsSection({ value, onChange }) {
  const items = value?.items || [];

  const setItems = (next) => onChange({ ...value, items: next });
  const setItem = (index, field, fieldValue) =>
    setItems(items.map((item, i) => (i === index ? { ...item, [field]: fieldValue } : item)));

  return (
    <div className="border-t pt-6">
      <label className="flex items-center gap-2 mb-4">
        <input
          type="checkbox"
          checked={!!value?.enabled}
          onChange={(e) => onChange({ ...value, enabled: e.target.checked })}
          className="h-4 w-4"
        />
        <span className="text-lg font-semibold text-gray-900">
          Incluir resultados de exámenes previos
        </span>
      </label>

      {value?.enabled && (
        <div className="space-y-3">
          {items.map((item, index) => (
            <div key={index} className="grid grid-cols-12 gap-2 items-start">
              <input
                className="col-span-4 border rounded px-3 py-2"
                placeholder="Nombre del examen"
                value={item.name || ''}
                onChange={(e) => setItem(index, 'name', e.target.value)}
              />
              <input
                type="date"
                className="col-span-3 border rounded px-3 py-2"
                value={item.date || ''}
                onChange={(e) => setItem(index, 'date', e.target.value)}
              />
              <input
                className="col-span-4 border rounded px-3 py-2"
                placeholder="Resultado"
                value={item.result || ''}
                onChange={(e) => setItem(index, 'result', e.target.value)}
              />
              <button
                type="button"
                aria-label={`Quitar examen ${index + 1}`}
                className="col-span-1 text-red-600"
                onClick={() => setItems(items.filter((_, i) => i !== index))}
              >
                Quitar
              </button>
            </div>
          ))}

          <button
            type="button"
            className="text-primary-600 font-medium"
            onClick={() => setItems([...items, { name: '', date: '', result: '' }])}
          >
            + Agregar examen
          </button>

          <textarea
            className="w-full border rounded px-3 py-2"
            rows={2}
            placeholder="Observaciones"
            value={value?.notes || ''}
            onChange={(e) => onChange({ ...value, notes: e.target.value })}
          />
        </div>
      )}
    </div>
  );
}

export default PreviousLabResultsSection;
